<script lang="ts" setup>
import {
  type Content,
  ContentDisplayType,
} from '@/ts/types/dto/interventions-dto';
import ReadOnlyNonCollapsableTitle from '@/vue/molecules/read-only/helpers/read-only-non-collapsable-title.vue';
import BalmMediaPlayer from '@/vue/molecules/balm-media-player.vue';
import LightboxVideo from '@/vue/molecules/lightbox-video.vue';
import {ReccoMediaType} from '@/ts/types/component/recco/media.type';
import {calculateMediaUrl} from '@/ts/utils/pure-functions';

defineProps<{
  content: Content
}>();
</script>

<template>
  <read-only-non-collapsable-title
    v-if="content.displayType !== ContentDisplayType.NO_TEXT"
    :header="content.name!"
    :active="false"
  >
    <div v-safe-html="content.contentHTML"/>
    <lightbox-video
      v-if="content.video"
      :video-src="calculateMediaUrl(content.video)"
      :poster-src="content.image ? calculateMediaUrl(content.image) : undefined"
      :poster-alt="content.name ?? ''"
      class="player"
    />
    <balm-media-player
      v-if="content.audio"
      compact
      :src="calculateMediaUrl(content.audio)"
      :media-type="ReccoMediaType.Audio"
      show-volume-control
      show-playback-speed
      class="player"
    />
  </read-only-non-collapsable-title>
</template>
<style lang="scss" scoped>
.player {
  margin-top: var(--Spacing-spacing-5);
  display: block;
  width: 100%;
}

</style>
